import { ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageNumberFromUrl, usePerPageValueFromUrl } from 'idsk-react-components';

const ScrollToTop = (): ReactElement | null => {
  const { pathname } = useLocation();
  const { page } = usePageNumberFromUrl('page');
  const { perPageValue } = usePerPageValueFromUrl();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, page, perPageValue]);

  return null;
};

export default ScrollToTop;
